import { handleClickColor } from "../../Common/Util";

export function RashiPlanetChart ({planetaryPositionData,userData}) {
  return(
    <table class="m-0 p-0 table table-bordered table-hover align-middle caption-top text-center">
      <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Planets</h4></caption>
      <thead class="m-0 p-0">
        <tr class="m-0 p-0">
          <th class="m-0 p-0">Planet</th> 
          <th class="m-0 p-0">Star</th> 
          <th class="m-0 p-0">Patham</th> 
          <th class="m-0 p-0">Star Lord</th> 
        </tr>
      </thead>
      <tbody class="m-0 p-0">
      {planetaryPositionData.map((planet) => (
        <tr class="m-0 p-0" onClick={handleClickColor}>
          <th class="m-0 p-0 ps-1 bg-transparent text-start text-nowrap">{planet[0]}</th>
          <td class="m-0 p-0 ps-1 pe-1 bg-transparent text-start">{planet[7].substring(0,planet[7].length-3)}</td>
          <td class="m-0 p-0 bg-transparent">{planet[7].substring(planet[7].length-2,planet[7].length-1)}</td>
          <td class="m-0 p-0 bg-transparent">{planet[9]}</td>
        </tr>
      ))}
      </tbody>  
    </table>
  );
}